import * as tslib_1 from "tslib";
import { Vue, Prop, Component, Watch } from 'vue-property-decorator';
import { env } from '@ivy/fts/envInfo/envInfo';
import { uploadEvent } from '@/api/goods/statistics';
let DiscountSale = class DiscountSale extends Vue {
    constructor() {
        super(...arguments);
        this.timeText = '距结束还剩:';
        this.timer = null;
        this.canShow = false;
        // discountData: any = {}
        this.limitTime = [];
        this.typeMap = {
            presell: '预付定金',
            limit_buy: '限时折扣',
            group: '限时拼团',
            limit_free: '限时免费',
            will_sale: '即将开售',
            will_out: '即将停售',
            is_out: '已下架',
        };
    }
    get isDistribution() {
        return true;
    }
    get disDeadLine() {
        return '1天12:27:34';
    }
    curLevelChanged(val, oldVal) {
        console.log(this.curLevel, this.curLevel.virtual_inventory_qty, '234');
        if (val) {
            this.countdown();
        }
    }
    discountDataChanged(val, oldVal) {
        if (val) {
            this.countdown();
        }
    }
    //vip节省价格
    get vipSavemoney() {
        if (this.curLevel.activityType === 'vipPrice' &&
            this.curLevel.vipPrice !== null) {
            return (this.curLevel.salePrice - this.curLevel.vipPrice).toFixed(2);
        }
        else {
            return '';
        }
    }
    //获取是否有买赠
    get isBuyGift() {
        return this.discountTypeName === '买赠活动';
    }
    //是否有会员价
    get havevipPrice() {
        if (this.curLevel.activityType === 'vipPrice' &&
            this.curLevel.vipPrice !== null) {
            return true;
        }
        else {
            return false;
        }
    }
    get priceObj() {
        let price = {
            discountPrice: this.curLevel.salePrice,
            basePrice: this.curLevel.originSalePrice || this.curLevel.originPrice,
        };
        return price;
    }
    get showOriginSalePrice() {
        if (this.curLevel.activities &&
            this.curLevel.activities.gift &&
            Object.keys(this.curLevel.activities.gift).length !== 0) {
            return true;
        }
        else {
            return false;
        }
    }
    // 背景高度
    get discountWrapHeight() {
        if (this.havevipPrice ||
            (this.curLevel.activities &&
                this.curLevel.activities.gift &&
                Object.keys(this.curLevel.activities.gift).length !== 0)) {
            if (this.havevipPrice) {
                if (this.isVip) {
                    return 'discount-wrap-vip';
                }
                else {
                    return 'discount-wrap-novip';
                }
            }
            else {
                return 'discount-wrap-gift';
            }
        }
        else {
            return 'discount-wrap-normal';
        }
    }
    get showNum() {
        return this.discountTypeName === '' && this.havevipPrice === false;
    }
    //活动名称
    get discountTypeName() {
        let lastname = '';
        if (!this.havevipPrice &&
            this.curLevel.activities &&
            this.curLevel.activities.gift &&
            Object.keys(this.curLevel.activities.gift).length !== 0) {
            lastname = '买赠活动';
        }
        return lastname;
    }
    async mounted() {
        // 默认展示折扣价格
        //     @Prop() skuActivity: any[]
        // @Prop() spu: any
        // @Prop() skus: any[]
        // @Prop() curLevel: any
        // @Prop({ default: {} }) discountData: any
        this.countdown();
    }
    // 分销总体数据
    async setDefaultLimit() {
        let keys = Object.keys(this.skuActivity);
        if (keys.length === 0) {
            return;
        }
    }
    async countdown() {
        //原计算时间方法,普通商品无倒计时
    }
    // 跳转到会员页面
    toMember() {
        //Click_GoodsDetail_Vip 商品详情页点击开通会员按钮
        uploadEvent.sendRecord('Click_GoodsDetail_Vip', '', {
            GoodsName: this.curLevel.title || '',
            SkuID: this.curLevel.id,
        }, [
            ['p1', 'GoodsName'],
            ['p2', 'SkuID'],
        ]);
        if (this.isApp) {
            env.commonJump(`ivydadReadtool://my/vip`);
        }
        else {
            // this.$router.push({
            //   path: '/goodsView',
            //   query: { spuId: '11261' },
            // })
            let _redirect = `${window.location.origin}/goods/goodsView?spuId=11261`;
            window.location.href = _redirect;
        }
    }
};
tslib_1.__decorate([
    Prop()
], DiscountSale.prototype, "skuActivity", void 0);
tslib_1.__decorate([
    Prop()
], DiscountSale.prototype, "spu", void 0);
tslib_1.__decorate([
    Prop()
], DiscountSale.prototype, "skus", void 0);
tslib_1.__decorate([
    Prop()
], DiscountSale.prototype, "curLevel", void 0);
tslib_1.__decorate([
    Prop({ default: {} })
], DiscountSale.prototype, "discountData", void 0);
tslib_1.__decorate([
    Prop()
], DiscountSale.prototype, "isApp", void 0);
tslib_1.__decorate([
    Prop()
], DiscountSale.prototype, "isVip", void 0);
tslib_1.__decorate([
    Watch('curLevel.id')
], DiscountSale.prototype, "curLevelChanged", null);
tslib_1.__decorate([
    Watch('discountData.activity_type')
], DiscountSale.prototype, "discountDataChanged", null);
DiscountSale = tslib_1.__decorate([
    Component({
        name: 'DiscountSale',
        filters: {
            filterInt: function (price = '') {
                return price.toString().split('.')[0];
            },
            filterFloat: function (price = '') {
                return price.toString().split('.')[1] !== '00'
                    ? parseFloat(price)
                        .toString()
                        .split('.')[1]
                    : '00';
            },
            filterVipprice: function (price = '') {
                return parseFloat(price);
            },
        },
    })
], DiscountSale);
export default DiscountSale;
